import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'calendar-check-icon',
  templateUrl: './calendar-check-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CalendarCheckIconComponent {}
